// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { FileKind } from "../../../define/FileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import { MansionKind } from "../../../define/MansionKind";
import { MatchMiaiKind } from "../../../define/MatchMiaiKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { TaskKind } from "../../../define/TaskKind";
import { UIKind } from "../../../define/UIKind";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import { backpackOpenType } from "../../config/backpackConst";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { AccountItem, NormalBackpackI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import UserDataManage from "../../model/UserDataManage";
import BackpackPrefab from "../backpack/BackpackPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EnterLayerEventShow extends BasePopUpLayer {

	@property({ type: cc.Sprite, displayName:'' })
	sprBg: cc.Sprite = null;

	@property({ type: cc.Node, displayName:'' })
	sprArrow: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprPeople: cc.Sprite = null;

    @property({type:cc.Label,displayName:"npc名字"})
    lbName:cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelChat: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	btnSelect: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeBtnList: cc.Node = null;

    @property({type:cc.Node,displayName:"物品节点"})
    objNode:cc.Node = null;

    private csvEvents: any = null;
    /** 正在打印的文本 */
    private curShowText: string = '';
    /** 正在显示文本 */
    private bShowTexting: boolean = false;
    private curCsvInfo: any = null;
    private delayNextTalking = false;
    private nextId: string = null;

    private curObjId:string = null;
    /** 上一个显示的背景 */
    private lastShowBg: string = null;

    private bDeleteNodeStr = true;

    start () {
        NormalGameManager._instance.pauseTimer();
        this.btnSelect.active = false;
        this.initLayer();
        O1HD.getModules().uiControlModule.hideLoading();
        this.addLayerTouchEvent();
    }

    protected onDestroy(): void {
        if (this.bDeleteNodeStr) {
            NormalGameManager._instance.resumeTimer();
            O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.EnterLayerEventShow);
        }
    }

    initLayer() {
        let id = this._carryData.id;
        let csvInfo = CsvDataManage.instance.getCsvDataItem(this._carryData.eventArrCsv, id);
        if (!csvInfo) {
            console.error(`未找到表格数据`);
            return;
        }

        let csvEvents = this.csvEvents = CsvDataManage.instance.getCsvData(this._carryData.eventCsv);
        if (!csvEvents) {
            console.error(`未找到表格`);
            return;
        }
        this.startTalk(csvInfo.event_id);
    }

    /**
     * 加载角色信息
     */
    loadPeople(){
        let info = this.curCsvInfo;
        let name = info[2];
        let head = info[3];
        this.sprPeople.node.active = false;
        if(name == ""){
            name = "自己";
            let gameData = NormalGameManager._instance.getGameData();
            let csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEVEL, gameData.m_officialLv);
            if (csvInfo) {
                head = csvInfo.player_head;
            }
            this.lbName.string = name;
            return;
        } else {
            this.lbName.string = name;
        }
        
        if(head == ""){
            // head = "default";
        }

        if (utilsModel.isValidNumberValue(head)) {
            getOneBundleByInstant(BUNDLE_SMALL_NAME.eventGameBundle).load(`assets/eventHead/${head}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
                if(err){
                    console.error(err,"#87 method loadPeople fail");
                    return;
                }
                this.sprPeople.node.active = true;
                this.sprPeople.spriteFrame = spr;
            });
        }
    }

    /**
     * 开始第一段对话
     * @param id 
     * @returns 
     */
    async startTalk(id: string) {
        this.curObjId = null;
        this.delayNextTalking = false;
        let info = this.csvEvents[id];
        if (!info) {
            console.error(`未找到数据 事件id = ${id}`);
            return;
        }

        this.sprBg.node.active = false;
        this.curCsvInfo = info;
        this.loadPeople();
        let title = this.csvEvents.title;
        let desc:string = info[title.desc];
        let descAry = desc.split("#");
        this.objNode.active = false;
        if(descAry[1]){
            if(descAry[1].includes("backId：")){
                let backId = descAry[1].substring(7);
                this.curObjId = backId;
            }
        }
        this.showBg(title.event_bg && info[title.event_bg]);
        await this.showTextAni(descAry[0]);
        if(descAry[1]){
            if(descAry[1].includes("backId：")){
                let backId = descAry[1].substring(7);
                this.loadBackItem(backId);
            }else{
                this.objNode.active = false;
            }
        }
    }

    async showBg(event_bg: string) {
        if (event_bg == this.lastShowBg) {
            this.sprBg.node.active = true;
            return;
        }
        this.lastShowBg = event_bg;
        if (!utilsModel.isValidNumberValue(event_bg)) {
            return;
        }
        this.sprBg.node.active = true;
        let bundle = await getOneBundle(BUNDLE_SMALL_NAME.eventGameBundle);
        bundle.load(`assets/EnterLayerEvent/bg/${event_bg}`,cc.SpriteFrame,(err,assets:cc.SpriteFrame)=>{
            if(err){
                console.debug("加载图片失败",err);
                return;
            }
            this.sprBg.spriteFrame = assets;
        });
    }

    /**
     * 加载一个背包物品
     * @param backId 
     */
    async loadBackItem(backId:string){
        this.objNode.active = true;
        let backConfig:NormalBackpackI = backPackEventMap()[backId];
        let spPath:string = backConfig.spPath;
        let name:string = backConfig.name;
        let lbName:cc.Label = this.objNode.getChildByName("lbName").getComponent(cc.Label);
        let sprite:cc.Sprite = this.objNode.getChildByName("sp").getComponent(cc.Sprite);
        lbName.string = name;
        let bundle = await getOneBundle(BUNDLE_SMALL_NAME.backPackGameBundle);
        bundle.load(`backpackAssets/objSp/${spPath}`,cc.SpriteFrame,(err,assets:cc.SpriteFrame)=>{
            if(err){
                console.debug("加载图片失败",err);
                return;
            }
            sprite.getComponent(cc.Sprite).spriteFrame = assets;
        });
    }

    /**
     * 选择按钮回调
     * @param event 
     * @param data 
     * @returns 
     */
    onClickSelect(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let idx = Number(data);
        let title = this.csvEvents.title;
        let strEvent = this.curCsvInfo[title.event];
        let eventArr = utilsModel.splitLineFeed(strEvent);
        let retEvent = eventArr[idx];
        if (!retEvent) {
            console.error(`数据获取错误`);
            return;
        }
        this.eventDispose(retEvent);
    }

     /**
     * 显示文本动画
     * @param text 
     */
     async showTextAni(text: string) {
        return new Promise<void>(resolve=>{
            this.curShowText = text;
            this.bShowTexting = true;
    
            this.labelChat.node.stopAllActions();
            this.labelChat.string = '';
            this.sprArrow.active = true;
            let strList = text.split('');
            let idx = 0;
            let length = strList.length - 1;
            cc.tween(this.labelChat.node)
                .delay(0.1)
                .call(() => {
                    let strTmp = this.labelChat.string + strList[idx];
                    this.labelChat.string = strTmp;
                    idx++;
    
                    if (idx >= length) {
                        this.endTextShow();
                    }
                })
                .union()
                .repeat(length)
                .call(resolve)
                .start();
        });
    }

    /**
     * 结束显示文本
     */
    endTextShow() {
        this.bShowTexting = false;
        this.labelChat.node.stopAllActions();
        this.labelChat.string = this.curShowText;

        let title = this.csvEvents.title;
        let strSelect = this.curCsvInfo[title.select];
        let strEvent = this.curCsvInfo[title.event];
        if (utilsModel.isValidNumberValue(strSelect)) {
            this.sprArrow.active = false;
            let selectArr = utilsModel.splitLineFeed(strSelect);
            let eventArr = utilsModel.splitLineFeed(strEvent);
            let i = 0;
            this.nodeBtnList.removeAllChildren();
            for (let o of selectArr) {
                if (this.isShowSelectBtn(eventArr && eventArr[i])) {
                    let btnNode = cc.instantiate(this.btnSelect);
                    btnNode.active = true;
                    this.nodeBtnList.addChild(btnNode);

                    let label = btnNode.getChildByName('label').getComponent(cc.RichText);
                    label.string = o;

                    let btn = btnNode.getComponent(cc.Button);
                    btn.clickEvents[0].customEventData = '' + i;
                }
                i ++;
            }
        } else {
            this.sprArrow.active = true;
        }
        if(this.curObjId){
            this.loadBackItem(this.curObjId);
        }
    }

    isShowSelectBtn(strEvent: string) {
        if (!strEvent) {
            return true;
        }

        let Type = GeneralKind.ValueChangeType;
        let eventArr = strEvent.split(FileKind.ResParseType.ITEM);
        for (let o of eventArr) {
            let splits = o.split(FileKind.ResParseType.SUB_ITEM);
            let type = splits[0];
            if (Type.OWN_DEDUCT_GOODS == type) {
                let goodsId = Number(splits[1]);
                let goodsItem = NormalGameManager._instance.getOneGood(goodsId);
                if (!goodsItem || goodsItem.num <= 0) {
                    return false;
                }
                break;
            } else if (Type.IS_OWN_GONGFU_1 == type) {
                if (!NormalGameManager._instance.getGameData().bMeetGongfu1) {
                    return false;
                }
                break;
            }
        }
        return true;
    }

    /**
     * 下一步
     * @returns 
     */
    async nextStep() {
        let title = this.csvEvents.title;
        let strSelect = this.curCsvInfo[title.select];
        if (!utilsModel.isValidNumberValue(strSelect)) {
            let strNext = this.curCsvInfo[title.next];
            let event = this.curCsvInfo[title.event];
            if (utilsModel.isValidNumberValue(event)) {
                let eventArr = utilsModel.splitLineFeed(event);
                let isTrue = await this.eventDispose(eventArr[0]);
                if (isTrue) {
                    return;
                }
            }
            if (utilsModel.isValidNumberValue(strNext)) {
                this.nextTalk(strNext);
            } else {
                if (!utilsModel.isValidNumberValue(event)) {
                    this.exitLayer();
                }
            }
        }
    }

    /**
     * 下一句聊天
     * @param id 
     */
    nextTalk(id: string) {
        this.delayNextTalking = true;
        this.nextId = id;
        cc.tween(this.node)
        .delay(0.01)
        .call(()=> {
            this.delayNextTalking = false;
            this.startTalk(id);
        })
        .start();
    }

    /**
     * 显示隐藏ui
     * @param visible 
     */
    showUI(visible: boolean) {
        this.node.active = visible;
    }

    /**
     * 事件处理
     * @param strEvent 
     * @returns 
     */
    eventDispose(strEvent: string) {
        return new Promise<boolean>(async resolve=>{
            let gameManager = NormalGameManager._instance;
            let gameData = gameManager.getGameData();
            let officialLv = gameData.m_officialLv;
            // let reputation = gameData.m_reputation;
            let curDay = gameManager.getCurrentDay();
            let eventArr = strEvent.split(FileKind.ResParseType.ITEM);
            let Type = GeneralKind.ValueChangeType;
            let next:string = null;
            for (let o of eventArr) {
                let splits = o.split(FileKind.ResParseType.SUB_ITEM);
                let type = splits[0];
                if (type == Type.GOLD) {
                    let goldNum = Number(splits[1]);
                    let ownGold = O1HD.getServices().userSrv.getCoins();
                    if ((ownGold + goldNum) < 0) {
                        O1HD.getModules().uiControlModule.showMessageBox("铜钱不足");
                        // NormalGameManager._instance.openBankPage();
                        resolve(true);
                        return;
                    }
                } else if (type == Type.GOODS_DEDUCT) {
                    let goodsId = Number(splits[1]);
                    let goodsItem = NormalGameManager._instance.getOneGood(goodsId);
                    let goodsCount = Number(splits[2]);
                    let goodsHint = splits[3];
                    if (!goodsItem || goodsItem.num < goodsCount) {
                        O1HD.getModules().uiControlModule.showMessageBox(goodsHint);
                        resolve(true);
                        return;
                    }
                }
            }
            let bOwnNext = false;

            let addGold = 0;
            let addExp = 0;
            let bAddGoods = false;
            let addGoodsList = {};
            let bExitLayer = false;
            let exitLayerFun = null;
            let bCloseSelf = false;
            let bExitLayerSelf = false;
            
            for (let o of eventArr) {
                let splits = o.split(FileKind.ResParseType.SUB_ITEM);
                let type = splits[0];
                switch(type) {
                    case Type.GOLD: {
                        let goldNum = Number(splits[1]);
                        addGold += goldNum;
                        O1HD.getServices().userSrv.setCoins(goldNum, true);
                    }
                    break;
                    case Type.NEXT_ID: {
                        next = splits[1];
                        bOwnNext = true;
                    }
                    break;
                    case Type.NEXT_FIXED_DAY_EVENT: {
                        let nextFixedId = splits[1];
                        gameData.fixedTimeEvent.nextEvent.push(nextFixedId);
                        gameManager.writeGameData();
                    }
                    break;
                    case Type.EXIT_LAYER: {
                        bCloseSelf = true;
                        bOwnNext = true;
                        bExitLayer = true;
                        exitLayerFun = this._carryData.exitLayer;
                    }
                    break;
                    case Type.SAVE_EXIT: {
                        bExitLayerSelf = true;
                        bExitLayer = true;
                        exitLayerFun = this._carryData.exitLayer;
                        bOwnNext = true;
                    }   
                    break;
                    case Type.GOODS_GET: {
                        let goodsId = Number(splits[1]);
                        let goodsNum = Number(splits[2] || 1);
                        if (goodsNum > 0) {
                            bAddGoods = true;
                        }
                        if (!addGoodsList[goodsId]) {
                            addGoodsList[goodsId] = 0;
                        }
                        addGoodsList[goodsId] += goodsNum;
                    }
                    break;
                    case Type.GOODS_GET_HIDE: {
                        let goodsId = Number(splits[1]);
                        let goodsNum = Number(splits[2] || 1);
                        NormalGameManager._instance.onPushGoods(goodsId, goodsNum);
                    }
                    break;
                    case Type.GOODS_DEDUCT: {
                        let goodsId = Number(splits[1]);
                        let goodsCount = Number(splits[2]);
                        NormalGameManager._instance.onOutGoods(goodsId, goodsCount);
                    }
                    break;
                    case Type.PRESTIGE: {
                        let exp = Number(splits[1]);
                        addExp += exp;
                        this.addPrestige(exp);
                    }
                    break;
                    case Type.RATE_PAYMENT: {
                        this.addSpecialRepayment(
                            splits[1]
                            , splits[2]
                            , splits[3]
                            , Number(splits[4])
                            , Number(splits[5])
                            , 0
                        );
                    }
                    break;
                    case Type.SPECAIL_REPAYMENT: {
                        this.addSpecialRepayment(
                            splits[1]
                            , splits[2]
                            , splits[3]
                            , Number(splits[4])
                            , Number(splits[5])
                            , Number(splits[6])
                        );
                    }
                    break;
                    case Type.IS_OFFICIAL: {
                        let oLv = Number(splits[1]);
                        let oNextId = splits[2];
                        let nNextId = splits[3];
                        bOwnNext = true;
                        next = officialLv >= oLv ? oNextId : nNextId
                    }   
                    break;
                    case Type.FLUEGER: {
                        let eventId = splits[1];
                        NormalGameManager._instance.addOneWeChatTriggerLink(eventId);
                    }   
                    break;
                    case Type.SHOW_PACKSACK: {
                        let url = "backpack/backpackPrefab";
                        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
                        if(prefab){
                            let backpack = cc.instantiate(prefab);
                            backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.normal,null)
                            cc.Canvas.instance.node.addChild(backpack);
                        }
                    }
                    break;
                    case Type.OPEN_PACKSACK: {
                        await new Promise<void>(async aresolve=>{
                            let url = "backpack/backpackPrefab";
                            let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
                            if(prefab){
                                let backpack = cc.instantiate(prefab);
                                backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.select,null,(item:NormalBackpackI)=>{
                                    NormalGameManager._instance.onOutGoods(item.id,1);
                                    let bSelectCorrect = item.id.toString() == splits[1];
                                    if(bSelectCorrect){
                                        next = splits[2];
                                        this.nodeBtnList.removeAllChildren();
                                    }
                                    // resolve(!bSelectCorrect);
                                    
                                    aresolve();
                                });
                                this.node.addChild(backpack);
                            }
                        });
                        if (next) {
                            bOwnNext = true;
                        } else {
                            resolve(true);
                            return;
                        }
                        break;
                    }   
                    case Type.UPGRADE_OFFICIALLV:{
                        NormalGameManager._instance.promoteLevel();
                        resolve(false);
                        break;
                    }
                    case Type.BANISH_FRONTIER:
                    case Type.PUSH_DIE_JAIL: {
                        this.endGameEvent(type == Type.PUSH_DIE_JAIL);
                        resolve(true);
                        return;
                    }
                    case Type.GUIDE_ENTER_LAYER: {
                        O1HD.emit("normalMode.guideEnterModule", splits[1]);
                        this.closeLayer();
                        resolve(true);
                        return;
                        // break;
                    }
                    case Type.OWN_DEDUCT_GOODS: {
                        let goodsId = Number(splits[1]);
                        NormalGameManager._instance.onOutGoods(goodsId, 1);
                    }
                    break;
                    case Type.STUDY_GONGFU_1: {
                        gameData.bMeetGongfu1 = true;
                        gameManager.writeGameData();
                    }
                    break;
                    case Type.SUCCESS_BUY_MANSION: {
                        gameData.bBuyMansion = true;
                        gameManager.writeGameData();
                    }
                    break;
                    case Type.OPEN_MATCH_MIAI_SECOND_LEVEL: {
                        O1HD.emit(MessageEventKind.EventName.START_MATCH_MIAI_SECOND_LEVEL);
                    }
                    break;
                    case Type.OPEN_MAIN_EVENT: {
                        let mainEId = splits[1];
                        this.openMainEvent(mainEId);
                    }
                    break;
                    case Type.DELAY_OPEN_MAIN_EVENT: {
                        this.delayOpenMainEvent(splits);
                    }
                    break;
                    case Type.FINISH_MATCH_MIAI_SECOND_LEVEL: {
                        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
                        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
                        matchMiaiData.bEndSecond = true;
                        matchMiaiData.bShowCupidArrow = true;
                        matchMiaiData.bOpenBridePriceDTime = true;
                        matchMiaiData.bridePrriceStartTime = curDay;
                        matchMiaiData.saveLocalData();

                        NormalGameManager._instance.taskDataManage.addNewFinishTask(TaskKind.TaskId.TASK_3);
                    }
                    break;
                    case Type.RESET_MATCH_MIAI_LEVEL: {
                        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
                        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
                        matchMiaiData.bShowCupidArrow = true;
                        matchMiaiDataManage.resetLevelData();
                        matchMiaiData.saveLocalData();
                    }
                    break;
                    case Type.GET_CUPID_ARROW: {
                        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
                        matchMiaiDataManage.addCupidArrow();
                    }
                    break;
                    case Type.OPEN_SUPER_POWER_COMPOUND: {
                        this.openSuperPowerCompound();
                    }
                    break;
                    case Type.MATCH_MIAI_BRIDE_PRICE: {
                        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
                        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
                        matchMiaiData.bBridePrice = true;
                        matchMiaiData.bOpenBridePriceDTime = false;
                        matchMiaiData.bridePrriceStartTime = 0;
                        matchMiaiData.saveLocalData();

                        UserDataManage.instance.mansionDataManage.dataCompatibility();
                    }
                    break;
                    case Type.BREAK_WECHAT: {
                        for (let si = 1; si < splits.length; si++) {
                            let wid = splits[si];

                            if (gameData.ariseLinks) {
                                let widx = gameData.ariseLinks.indexOf(wid);
                                if (widx != -1) {
                                    gameData.ariseLinks.splice(widx, 1);
                                }
                            }
                            for (let j = 0; j < gameData.weChatLinks.length; j++) {
                                let wLink = gameData.weChatLinks[j];
                                if (wLink.linkId == wid) {
                                    gameData.weChatLinks.splice(j, 1);
                                    break;
                                }
                            }
                            gameManager.writeGameData();
                        }
                    }
                    break;
                    case Type.TRIGGER_TASK: {
                        let taskId = splits[1];
                        gameManager.taskDataManage.addNewTask(taskId);
                    }
                    break;
                    case Type.FINISH_TASK: {
                        let taskId = splits[1];
                        gameManager.taskDataManage.addNewFinishTask(taskId);
                    }
                    break;
                    case Type.TAKE_TO_WIFE: {
                        let wifeId = splits[1];
                        this.onTakeToWife(wifeId);
                    }
                    break;
                    case Type.GOLD_DEDUCT_SPECIAL: {
                        let goldNum = Number(splits[1]);
                        let gold = O1HD.getServices().userSrv.getCoins();
                        goldNum = Math.min(gold, goldNum);
                        O1HD.getServices().userSrv.setCoins(-goldNum, true);
                    }
                    break;
                    case Type.VIDEO_LOOK: {
                        let bSuccess = await new Promise<boolean>(resolve2 => {
                            utilsModel.loadAndShowVideoAdTrans(()=>{
                                cc.log('观看成功')
                                resolve2(true);
                            },()=>{
                                cc.log('观看失败')
                                resolve2(false);
                            }, null, "事件中广告");
                        });
                        if (!bSuccess) {
                            resolve(true);
                            return;
                        }
                    }
                    break;
                    case Type.OPEN_SELECT_CONCUBINE:{
                        let url = "prefab/chooseConcubineGame";
                        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.chooseConcubineGameBundle,url);
                        if(prefab){
                            let p = cc.instantiate(prefab);
                            O1HD.Canvas().addChild(p);
                        }
                        break;
                    }
                    case Type.SELECT_CONCUBINE_RANDSORT:{
                        O1HD.emit(MessageEventKind.EventName.SELECT_CONCUBINE_RANDSORT);
                        break;
                    }
                    case Type.CLOSE_CONCUBINE:{
                        O1HD.emit(MessageEventKind.EventName.CLOSE_CONCUBINE);
                        break;
                    }
                    case Type.CLOSE_SELECT_CONCUBINE:{
                        O1HD.emit(MessageEventKind.EventName.CLOSE_SELECT_CONCUBINE);
                        break;
                    }
                }
            }

            if (addGold > 0 || addExp != 0 || bAddGoods) {
                this.node.active = false;
                await this.openGetGoodsLayer(addGold, addExp, addGoodsList);

                for (let ao in addGoodsList) {
                    let aCount = addGoodsList[ao];
                    NormalGameManager._instance.onPushGoods(Number(ao), aCount);
                }
                if (this.node && cc.isValid(this.node)) {
                    this.node.active = true;
                }
            }

            if (bCloseSelf) {
                this.closeLayer();
            }

            if (bExitLayerSelf) {
                this.exitLayer();
            }

            if (bExitLayer && exitLayerFun) {
                exitLayerFun();
            }

            if (this.node && cc.isValid(this.node)) {
                if(next){
                    this.nextTalk(next);
                }
                if (!bOwnNext) {
                    this.exitLayer();
                }
                this.nodeBtnList.removeAllChildren();
            }
            resolve(bOwnNext);
        });
    }

    openSuperPowerCompound() {
        let gameData = NormalGameManager._instance.getGameData();
        gameData.bShowSuperPowerBtn = true;
        NormalGameManager._instance.writeGameData();
        
        O1HD.emit(MessageEventKind.EventName.REFRESH_SPECIAL_BTN_STATE);
        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.SuperPowerCompoundLayer
            , null 
            , null
            , UI_Z_INDEX.DIALOG
        );
    }

    async openGetGoodsLayer(
        addGold: number
        , addExp: number
        , addGoodsList: any
    ) {
        return new Promise<void> (resolve=> {
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.EventGetGoodsLayer
                , null
                , {
                    parent: this
                    , addGold: addGold
                    , addExp: addExp
                    , addGoodsList: addGoodsList
                    , onComplete: ()=> {
                        resolve();
                    }
                }
                , UI_Z_INDEX.DIALOG
            );
        });
    }

    /**
     * 迎娶
     * @param wifeId 
     */
    onTakeToWife(wifeId: string) {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionData = mansionDataManage.mansionData;
        let wifeData = mansionDataManage.wifeDataManage.wifeData;
        let itemData = wifeData.lists.get(wifeId);
        if (itemData) {
            if (itemData.state == MansionKind.WifeState.WIFE) {
                return;
            }
            itemData.resetStateData();
            itemData.state = MansionKind.WifeState.WIFE;
        } else {
            itemData = wifeData.createItem(wifeId);
            itemData.state = MansionKind.WifeState.WIFE;
        }
        wifeData.saveLocalData();

        let csvInfos = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.WIFE, wifeId);
        let costs = Number(csvInfos && csvInfos.costs);
        if (!isNaN(costs)) {
            mansionData.costGold += costs;
            mansionData.saveLocalData();
        }
        UserDataManage.instance.mansionDataManage.mansionDataDispose();
    }

    delayOpenMainEvent(splits: string[]) {
        let mainEId = splits[1];
        let time = Number(splits[2]);
        let type = splits[3];
        let CondType = GeneralKind.DelayEventCondType;
        let gameData = NormalGameManager._instance.getGameData();
        switch(type) {
            case CondType.CON_TYPE1: {
                let dData = splits[4];
                let bFinishRecord = gameData.wechatRecordPoint.includes(dData);
                if (!bFinishRecord) {
                    return;
                }
            }
            break;
        }

        NormalGameManager._instance.addDelayTimeEvent(String(mainEId), time);
    }
   
    openMainEvent(mainEId: string) {
        let data = {
            id: mainEId
            , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
            , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
            , onComplete: this._carryData.onComplete
            , exitLayer: this._carryData.exitLayer
            , saveData: this._carryData.saveData
        }

        this.bDeleteNodeStr = false;
        NormalGameManager._instance.spliceOneNodeStrs(UIKind.UILayerTag.EnterLayerEventShow);
        utilsView.openEventLayer(
            null
            , data
            , UI_Z_INDEX.DIALOG
        );
    }

    /**
     * 添加特殊还款
     * @param title 
     * @param desc 
     * @param paramsArray 
     * @param totalFee 
     * @param needPayDays 
     * @param everyDayPay 
     */
    addSpecialRepayment(
        title: string
        , desc: string
        , paramsArray: string
        , totalFee: number
        , needPayDays: number
        , everyDayPay: number
    ) {
        let splitsArr = paramsArray.split(',');
        let accountItem:AccountItem = {
            uniqueId: NormalGameManager._instance.getGameData().userAccountInfo.length.toString(),
            title : title,
            desc : desc,
            paramsArray: splitsArr,
            totalFee : totalFee,
            needPayDays : needPayDays,
            hasPayDays : 0,
            everyDayPay: everyDayPay,
        };
        NormalGameManager._instance.setGameData({ userAccountInfo:[accountItem] }, true);
        NormalGameManager._instance.setGameData({ userAccountInfoNewMsg : 1 } , false);
    }

    /**
     * 提升声望
     * @param exp 
     */
    addPrestige(exp: number) {
        if (exp == 0) {
            return;
        }
        let gameManager = NormalGameManager._instance;
        gameManager.addExp(exp);
    }

    /**
     * 游戏结束
     * @param bPushDieJail 
     */
    endGameEvent(bPushDieJail: boolean) {
        O1HD.getServices().userSrv.setGameFail(1);
        this.showUI(false);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.GameEndEventLayer
            , null
            , {
                bPushDieJail: bPushDieJail
                , parent: this
            }
            , UI_Z_INDEX.DIALOG
        );
    }

    /**
     * 退出
     */
    exitLayer() {
        this.closeLayer();
        if (this._carryData.saveData) {
            this._carryData.saveData();
        }
    }
    
    /**
     * 关闭
     */
    closeLayer() {
        this.destroyNode();
        if (this._carryData.onComplete) {
            this._carryData.onComplete();
        }
    }

    destroyNode(): void {
        O1HD.emit(MessageEventKind.EventName.SELECT_CONCUBINE_PAUSE_STATUS,false);
        super.destroyNode();
    }

    /**
     * 点击屏幕
     * @param event 
     * @returns 
     */
    touchEventEnd(event: cc.Event.EventTouch){
        if (this.bShowTexting) {
            this.endTextShow();
            return;
        }

        if (this.delayNextTalking) {
            cc.Tween.stopAllByTarget(this.node);
            this.delayNextTalking = false;
            this.startTalk(this.nextId);
            return;
        }
        this.nextStep();

    }
}
